export default {
    linkList: {
        "companyLink": "Info",
        "termsOfService": "Nutzungsbedingungen",
        "privacyPolicy": "Datenschutzerklärung",
        "guaranteeOfRights": "Rechte von Datensubjekten",
        "customerSupport": "KUNDENSUPPORT",
        "cookiePolicy": "Cookie-Richtlinie",
        "declarationOfSafety": "Sicherheit・Sicherheitserklärung",
        "youthProtectionPolicy": "Erklärung über den Schutz der Jugend",
        "communityPolicy": "Communityrichtlinie",
        "operationPolicy": "Betriebsrichtlinie",
        "doNotSell": "Meine personenbezogenen Daten nicht verkaufen",
        "gameGrade": "게임이용등급",
        "communityPolicyView": "커뮤니티정책",
        "servicePolicy": "서비스정책",
        "termsOfUse": "회원정책",
        "operationPolicyNCJ": "운영방침",
        "reportRightsInfringement": "권리침해신고",
    },
    footerWords: {
        "gameRelatedLaw": "Zusätzliche Informationen gemäß den Glücksspielgesetzen",
        "brandInformation": "Informationen zum Unternehmensnamen",
        "copyright": "Copyright",
        "channelingInfo": "NCSOFT ist ein Zwischenhändler, der den E-Commerce von Channeling-Spielen innerhalb von plaync vermittelt, und ist keine Verkaufspartei der oben genannten Verkäufe.<br>Alle Verpflichtungen und Verantwortlichkeiten im Zusammenhang mit den angebotenen Channeling-Spielen liegen beim jeweiligen E-Commerce-Partner, und wir übernehmen keine Verantwortung für diesbezügliche Probleme.",
    },
    infoCS: {
        "businessInformation": "Unternehmensinformationen anzeigen",
        "infoAddress": "Name des Unternehmens NCSOFT Corporation, CEO: Kim Taek-Jin, Eintragsnummer des Unternehmens: 144-85-04244, E-Commerce-Eintrag: 2013-Gyeonggi Seongnam-1268",
        "mobile": "Adresse: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republik Korea. KUNDENSUPPORT: +82 1566-7004. Fax: +82 02-2186-3499.",
        "pc": "주소 경기도 성남시 분당구 대왕판교로 644번길 12 고객상담 1600-0020 팩스 02-2186-3553",
        "other": "Adresse: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republik Korea. KUNDENSUPPORT: +82 1600-0020 (PC-Spiel), +82 1566-7004 (Spiel für Mobilgeräte). Fax: +82 02-2186-3550 (PC-Spiel), +82 02-2186-3499 (Spiel für Mobilgeräte).",
        "none": "",

        "infoEmail": "E-Mail",
        "infoEmail-mobile": "MobileCS@ncsoft.com",
        "infoEmail-pc": "credit@ncsoft.com",
        "infoEmail-other": "credit@ncsoft.com/(PC Game)/MobileCS@ncsoft.com/(Mobile Game)",
        "infoEmail-none": "",
    },
    infoJP: {
        "jpTitle": "Titel",
        "jpGenre": "Genre",
        "jpPrice": "Preis",
        "jpPriceValue": "Gratis zum Spielen (enthält In-App-Käufe)",
        "jpOs": "Unterstütztes Betriebssystem",
        "jpDevelopedBy": "Entwickler/Herausgeber",
        "jpReleaseDay": "Veröffentlichungsdatum",
        "jpReleaseDayValue_LW": "04. November 2021",
    },
    country: {
        "KR": "Korea, Republik",
        "TW": "Taiwan",
        "RU": "Russland",
        "MY": "Malaysia",
        "SA": "Saudi-Arabien",
        "SG": "Singapur",
        "AE": "Vereinigte Arabische Emirate",
        "ID": "Indonesien",
        "JP": "Japan",
        "QA": "Katar",
        "TH": "Thailand",
        "PH": "Philippinen",
        "HK": "Hongkong",
        "UA": "Ukraine",
        "BY": "Belarus",
        "LT": "Litauen",
        "PL": "Polen",
        "GR": "Griechenland",
        "IL": "Israel",
        "KW": "Kuwait",
        "AT": "Österreich",
        "US": "USA",
        "CA": "Kanada",
        "DE": "Deutschland",
        "GB": "Vereinigtes Königreich",
        "FR": "Frankreich",
        "BR": "Brasilien",
        "IT": "Italien",
        "ES": "Spanien",
        "CL": "Chile",
        "NO": "Norwegen",
        "SE": "Schweden",
        "IE": "Irland",
        "PT": "Portugal",
        "FI": "Finnland",
        "DK": "Dänemark",
        "CH": "Schweiz",
        "AR": "Argentinien",
        "PE": "Peru",
        "MX": "Mexiko",
        "KZ": "Kasachstan",
        "UZ": "Usbekistan",
        "AZ": "Aserbaidschan",
        "GE": "Georgien",
        "MD": "Moldau",
        "AM": "Armenien",
        "MO": "Macao",
        "IN": "Indien",
        "PK": "Pakistan",
        "NL": "Niederlande",
        "RO": "Rumänien",
        "AU": "Australien",
        "TR": "Türkei",
        "EC": "Ecuador",
        "CO": "Kolumbien",
        "ZA": "Südafrika",
        "EG": "Ägypten",
        "NC": "Global",
    },
}
